import '.ak{border-radius:1.25rem;}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.h6{border:var(--border-default);}.ssr-plugin'
import '.h7{min-height:420px;}.ssr-plugin'
import '.ar{height:100%;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.h8{color:var(--content-secondary);}.ssr-plugin'
import '.h9{font-size:14px;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import { Style, styled } from 'inlines'

export interface SlideShareEmbedProps {
  src: string
  style?: Style
  className?: string
}

const ALLOWED_EMBED_HOSTS = new Set([
  'www.slideshare.net',
  'slideshare.net',
  'www.youtube.com',
  'youtube.com',
  'player.vimeo.com',
  'vimeo.com',
  'docs.google.com',
])

function isAllowedEmbedUrl(url: string): boolean {
  try {
    const { hostname } = new URL(url)
    return ALLOWED_EMBED_HOSTS.has(hostname)
  } catch {
    return false
  }
}

export const SlideShareEmbed = ({
  src,
  style,
  className,
}: SlideShareEmbedProps) => {
  if (!isAllowedEmbedUrl(src)) {
    return (
      <styled.div className={`${className} ak b5 h6 h7 ar d t ax`}
        style={{
          ...style,
        }}
      >
        <p className="h8 h9">
          Embed URL not allowed.
        </p>
      </styled.div>
    )
  }

  return (
    <styled.div className={`${className} ak b5 h6 h7 ar d e`}
      style={{
        ...style,
      }}
    >
      <iframe
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        allowFullScreen
        sandbox="allow-scripts allow-same-origin allow-presentation"
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          flex: 1,
        }}
      />
    </styled.div>
  )
}
